import React from 'react';
import PropTypes from 'prop-types';
import { Icons, PricePointsIcon } from '../../../../../zolaUI/Icons';

export default function CheckboxIcon({ className, apiKeyName }) {
  const props = { className, width: 16, height: 16, style: { marginRight: 4 } };

  if (apiKeyName !== 'SALE') return null;
  return <Icons Icon={PricePointsIcon} {...props} />;
}

CheckboxIcon.propTypes = {
  apiKeyName: PropTypes.string,
  className: PropTypes.string,
};
